import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculatePorchCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { porch, craftsmanQuality, propertyType } = improvementsForTransaction;
  const zipCode = identification.address.PostalCode;

  if (isUndefined(craftsmanQuality) || isUndefined(zipCode) || !porch || !propertyType) {
    return undefined;
  }

  const params = porch.area
    ? {
        hasFeature: ORDER_FEATURES.porch.hasFeature(improvementsForTransaction),
        propertyType,
        type: porch.type,
        quality: porch.quality ?? craftsmanQuality,
        sqft: AloftArea.fromNumber(porch.area.unitAmount, porch.area.unit),
        zipCode,
      }
    : {
        hasFeature: ORDER_FEATURES.porch.hasFeature(improvementsForTransaction),
        propertyType,
        type: porch.type,
        quality: porch.quality ?? craftsmanQuality,
        zipCode,
      };

  const calculator = getCraftsmanCost(costProps);
  return calculator.getPorchCost(params);
};

export const { selectPorchCost, selectZipOnlyPorchCost, selectPorchCosts, selectPorchCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculatePorchCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectPorchCost',
      zipOnly: 'selectZipOnlyPorchCost',
      costs: 'selectPorchCosts',
      display: 'selectPorchCostDisplay',
    },
  });
